/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Settings page components
import PageLayout from "examples/LayoutContainers/PageLayout";
import AgencyConnect from "./components/AgencyConnect";
import StripeCoonection from "./components/StripeCoonection";
import { Card } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { useAgencyInfo } from "context/agency";
import CopyToClipboard from "react-copy-to-clipboard";
import Success from "./components/Success";
import env from "config/env";
import MaybeConnect from "./components/MybeConnect";
import MybeAccountConnect from "./components/MybeAccountConnect";
import { useGhlLocations } from "queries/settingsIntegration";

function Settings() {
  const CUSTOM_URL = env.CUSTOM_URL
  const [agency] = useAgencyInfo()

  const { data: ghlLocations, isFetching: processing } = useGhlLocations(agency?._id);

  return (
    <PageLayout>
      <Grid container spacing={3}>
        <Grid item xs={12} >
          <SoftBox px={3} pt={4}>
            <SoftTypography variant="h4">Integration</SoftTypography>
          </SoftBox>
        </Grid>
        <Grid item xs={12}>
          <SoftBox mb={3}>
            <Grid container spacing={3}>
              <Grid style={{ margin: "0px 20px" }} item xs={12}>
                <StripeCoonection data={agency} />
              </Grid>
              {/* <Grid item style={{ margin: "0px 20px" }} xs={12}>
                <AgencyConnect />
              </Grid>
              <Grid item style={{ margin: "0px 20px" }} xs={12}>
                <MaybeConnect ghlLocations={ghlLocations} processing={processing} />
              </Grid> */}
            </Grid>
          </SoftBox>
        </Grid>
      </Grid>
    </PageLayout>
  );
}

export default Settings;
